import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxDiamantAlsterdorfBuExpStatus: 'idle',
    startProcessKxDiamantAlsterdorfBuExpError: undefined as any,
    loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus: 'idle',
    loadUserParamsProcessKxDiamantAlsterdorfBuExpError: undefined as any,

    processKxDiamantAlsterdorfBuExpList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxDiamantAlsterdorfBuExp = createAsyncThunk('processKxDiamantAlsterdorfBuExpSlice/startProcessKxDiamantAlsterdorfBuExp', async ({ processKxDiamantAlsterdorfBuExp }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxDiamantAlsterdorfBuExp/`,
        prepareData(processKxDiamantAlsterdorfBuExp),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxDiamantAlsterdorfBuExpStatus } = getState().processKxDiamantAlsterdorfBuExpSlice
        return startProcessKxDiamantAlsterdorfBuExpStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxDiamantAlsterdorfBuExp = createAsyncThunk('processKxDiamantAlsterdorfBuExpSlice/loadUserParamsProcessKxDiamantAlsterdorfBuExp', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxDiamantAlsterdorfBuExp/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus } = getState().processKxDiamantAlsterdorfBuExpSlice
        return loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus !== 'pending'
    }
})

const ProcessKxDiamantAlsterdorfBuExpSlice = createSlice({
    name: 'processKxDiamantAlsterdorfBuExpSlice',
    initialState,
    reducers: {
        resetstartProcessKxDiamantAlsterdorfBuExp: (state) => {
            state.job = undefined
            state.startProcessKxDiamantAlsterdorfBuExpError = undefined
        },
        resetstartProcessKxDiamantAlsterdorfBuExpError: (state) => {
            state.startProcessKxDiamantAlsterdorfBuExpError = undefined
        },
        resetloadUserParamsProcessKxDiamantAlsterdorfBuExp: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpError = undefined
        },
        resetloadUserParamsProcessKxDiamantAlsterdorfBuExpError: (state) => {
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpError = undefined
        },
        removeFromProcessKxDiamantAlsterdorfBuExpListById: (state, action) => {
            state.processKxDiamantAlsterdorfBuExpList = state.processKxDiamantAlsterdorfBuExpList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxDiamantAlsterdorfBuExpListByIds: (state, action) => {
            state.processKxDiamantAlsterdorfBuExpList = state.processKxDiamantAlsterdorfBuExpList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxDiamantAlsterdorfBuExpList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxDiamantAlsterdorfBuExpStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxDiamantAlsterdorfBuExpList = []
            state.startProcessKxDiamantAlsterdorfBuExpStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxDiamantAlsterdorfBuExp.pending, (state) => {
            state.startProcessKxDiamantAlsterdorfBuExpStatus = 'pending'
            state.startProcessKxDiamantAlsterdorfBuExpError = undefined
        })
        builder.addCase(startProcessKxDiamantAlsterdorfBuExp.fulfilled, (state, action) => {
            state.startProcessKxDiamantAlsterdorfBuExpStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxDiamantAlsterdorfBuExp.rejected, (state, action) => {
            state.startProcessKxDiamantAlsterdorfBuExpStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxDiamantAlsterdorfBuExpError = action.error.message
            } else {
                state.startProcessKxDiamantAlsterdorfBuExpError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxDiamantAlsterdorfBuExp.pending, (state) => {
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus = 'pending'
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpError = undefined
        })
        builder.addCase(loadUserParamsProcessKxDiamantAlsterdorfBuExp.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxDiamantAlsterdorfBuExp.rejected, (state, action) => {
            state.loadUserParamsProcessKxDiamantAlsterdorfBuExpStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxDiamantAlsterdorfBuExpError = action.error.message
            } else {
                state.loadUserParamsProcessKxDiamantAlsterdorfBuExpError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxDiamantAlsterdorfBuExp,
    resetstartProcessKxDiamantAlsterdorfBuExpError,
    resetloadUserParamsProcessKxDiamantAlsterdorfBuExp,
    resetloadUserParamsProcessKxDiamantAlsterdorfBuExpError,
    removeFromProcessKxDiamantAlsterdorfBuExpListById,
    removeFromProcessKxDiamantAlsterdorfBuExpListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxDiamantAlsterdorfBuExpSlice.actions
export default ProcessKxDiamantAlsterdorfBuExpSlice.reducer
